import React from 'react'
import { View } from 'react-native'

import { DS } from '@/design-system'

import { formatChipsNumber } from '@/components/GameAssets/Player/PlayerBox'

import * as cth from '@/router/(root)/cth/cthModule'
import * as d10 from '@/router/(root)/daily10/d10Module'
import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'

//import { pocketPickTheme as defaultTheme } from '@/screens/pocketPick/pocketPickTheme'
import { defaultTheme } from '@/components/Mini/theme'


/* Rules card, previous design */
//function RulesCard() {
  //const rules = [
    ////`Play up to ${DEFAULT_MAX_HANDS} hands against ${DEFAULT_BOT_COUNT} bots.`,
    //`Start with ${formatChipsNumber(DEFAULT_STARTING_CHIPS)} chips and see how much you can win in ${DEFAULT_MAX_HANDS} hands!`,
    //`Pre-flop folds don't count as hands, but only ${DEFAULT_FREE_PREFLOP_FOLDS} pre-flop folds are allowed. Consider which hands to play carefully.`
    ////`You need to think hard about which cards to play.`
  //]

  //return (
    //<Card style={{ gap: 32 }}>
      //<DS.Frame gap="8">
        //{rules.map(function (item, i) {
          //return <RulesCardItem key={i} item={item} />
        //})}
      //</DS.Frame>

      //<LeaderboardBtn />
    //</Card>
  //)
//}

//function RulesCardItem({ item }: { item: string }) {
  //return (
    //<DS.Text variant="Body Medium/Regular" color="Global/Black" style={{textAlign: "center"}}>
      //{item}
    //</DS.Text>
  //)
//}


function D10Rules(){

  const DEFAULT_STARTING_CHIPS = d10.useStore(s => s.DEFAULT_STARTING_CHIPS)
  const DEFAULT_MAX_HANDS = d10.useStore(s => s.DEFAULT_MAX_HANDS)
  const DEFAULT_FREE_PREFLOP_FOLDS = d10.useStore(s => s.DEFAULT_FREE_PREFLOP_FOLDS)

  const title = "How much can you win?";
  const subtitle = 
    "Start with"+" "+
    formatChipsNumber(DEFAULT_STARTING_CHIPS)+" "+
    "chips and see how much you can win in"+" "+
    DEFAULT_MAX_HANDS+" "+
    "hands! Pre-flop folds don't count as hands, but only"+" "+
    DEFAULT_FREE_PREFLOP_FOLDS+" "+
    "pre-flop folds are allowed. Consider which hands to play carefully."

    const theme = d10.useStore(s => s.theme)

    return (
      <Rules theme={theme} title={title} subtitle={subtitle}/>
    )
    
}


function CthRules(){

  const title = "Build the strongest hand";
  const subtitle = "Two hole cards are on the table. Pick three more to make the best five-card hand. 7 rounds a day."
  
  const theme = cth.useStore(s => s.theme)
   
  return (
    <Rules theme={theme} title={title} subtitle={subtitle}/>
  )
}


function PocketPickRules(){

  const ROUND_COUNT = pocketPick.useStore(s => s.ROUND_COUNT);
  const title = "Pick the best pocket card";
  const subtitle = "You're dealt one card. Choose the strongest second card from three. See how each pairing's starting hand strength stacks up — "+ROUND_COUNT+" hands a day."

  const theme = pocketPick.useStore(s => s.theme)
   
  return (
    <Rules theme={theme} title={title} subtitle={subtitle}/>
  )
}

function Rules({ theme=defaultTheme, title, subtitle }: { theme?: typeof defaultTheme; title: string; subtitle: string }) {

  const textColor = theme.textDefault;

  return (
    <View style={{gap:16}}>
      <DS.Text variant="Heading 3/Medium" style={{textAlign: "center", color: textColor, lineHeight: 30}}>
        {title}
      </DS.Text>
      <DS.Text variant="Body Large/Regular" style={{textAlign: "center", color: textColor}}>
        {subtitle}
      </DS.Text>
    </View>
  )
}

export { Rules, CthRules, D10Rules, PocketPickRules }
